import FetchApiError from "@/lib/openapi/api-error";
import { ExtractMutationOptions } from "@/lib/openapi/hooks";
import { useQueryClient } from "@tanstack/react-query";
import useUpdateMetaMutate, {
  UpdateMetaFetchParams,
  UpdateMetaResponse,
} from "./use-update-meta-mutate";

export const useUpdateMeta = (
  props: {
    queryOptions?: ExtractMutationOptions<
      UpdateMetaResponse,
      FetchApiError,
      UpdateMetaFetchParams,
      unknown
    >;
  } = {}
) => {
  const queryClient = useQueryClient();
  const { mutate: nativeMutate, ...rest } = useUpdateMetaMutate({
    queryOptions: {
      ...props.queryOptions,
      onSuccess: (...params) => {
        queryClient.invalidateQueries({
          predicate: (query) => {
            if (!Array.isArray(query.queryKey)) {
              return false;
            }

            const [first, second, third] = query.queryKey;
            const firstKey = typeof first === "string" ? first : undefined;
            const secondKey = typeof second === "string" ? second : undefined;
            const thirdKey = typeof third === "string" ? third : undefined;
            const isTelegramAuthorizationService =
              firstKey === "telegramAuthorization" ||
              firstKey === "telegramAuthorizations";

            if (
              isTelegramAuthorizationService &&
              (secondKey === "me" || secondKey === "initial")
            ) {
              return true;
            }

            if (firstKey === "me" || firstKey === "initial") {
              return true;
            }

            if (
              (isTelegramAuthorizationService &&
                secondKey === "/users" &&
                thirdKey === "get") ||
              (firstKey === "/users" && secondKey === "get")
            ) {
              return true;
            }
            return false;
          },
        });

        return props.queryOptions?.onSuccess?.(...params);
      }
    },
  });
  const mutate = (
    variables: Parameters<typeof nativeMutate>[0],
    options?: Parameters<typeof nativeMutate>[1]
  ) => {
    return nativeMutate(variables, options);
  };
  return {
    ...rest,
    mutate,
  };
};

export default useUpdateMeta;
